import { Injectable } from '@angular/core';
import { LiveTrackerSettings as LiveTrackerSettings } from '../interfaces/ILiveTrackerSettings';
import { environment } from '@env/environment';
import { ApplicationSettings } from '@app/shared/system/application-settings';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariablesService {

  public app: ApplicationSettings = new ApplicationSettings();
  public tracker: LiveTrackerSettings = new LiveTrackerSettings();
  public navizardSystemMenuSource: any | null = null;
  public navizardSystemMenu: any | null = null;


  public siteAddres: string;
  public apiAddress: string;
  public apiV2Address: string;
  public photoServerAddress: string;
  public photoServerApiAddress: string;

  
  public isDebugMode: boolean = false;

  constructor() {

    this.siteAddres = environment.site;
    this.apiAddress = environment.api;
    this.apiV2Address = environment.apiv2;
    this.tracker.address = this.resolveDefaultServiceAddress('tracker');
    
  }

  public setTrackerAddress(address?: string | null): string {
    this.tracker.address = this.resolveServiceAddress(address, 'tracker');
    return this.tracker.address;
  }

  public resolveTrackerAddress(): string {
    const resolved = this.resolveServiceAddress(this.tracker?.address, 'tracker');
    this.tracker.address = resolved;
    return resolved;
  }

  public buildTrackerUrl(path: string): string {
    return this.combineUrl(this.resolveTrackerAddress(), path);
  }

  public combineUrl(baseAddress: string, path: string): string {
    const normalizedBase = this.normalizeBaseAddress(baseAddress);
    if (!normalizedBase) {
      return '';
    }

    const normalizedPath = path?.startsWith('/') ? path : `/${path ?? ''}`;
    return `${normalizedBase}${normalizedPath}`;
  }

  private resolveServiceAddress(address: string | null | undefined, fallbackSubdomain: string): string {
    return this.normalizeBaseAddress(address) || this.resolveDefaultServiceAddress(fallbackSubdomain);
  }

  private normalizeBaseAddress(address: string | null | undefined): string {
    const raw = `${address ?? ''}`.trim();
    if (!raw || ['undefined', 'null'].includes(raw.toLowerCase())) {
      return '';
    }

    if (/^https?:\/\//i.test(raw)) {
      return raw.replace(/\/+$/, '');
    }

    if (raw.startsWith('//')) {
      return `${this.currentProtocol()}${raw}`.replace(/\/+$/, '');
    }

    // Service addresses must be absolute. If the setup value is a host name
    // without a scheme, promote it instead of letting SignalR treat it as a
    // relative URL under the web app domain.
    if (/^[a-z0-9.-]+(?::\d+)?(?:\/.*)?$/i.test(raw)) {
      return `${this.currentProtocol()}//${raw}`.replace(/\/+$/, '');
    }

    return '';
  }

  private resolveDefaultServiceAddress(subdomain: string): string {
    if (typeof window === 'undefined' || !window.location?.hostname) {
      return '';
    }

    return `${this.currentProtocol()}//${subdomain}.${window.location.hostname}`;
  }

  private currentProtocol(): string {
    if (typeof window === 'undefined' || !window.location?.protocol) {
      return 'https:';
    }

    return window.location.protocol;
  }

}
